import imageActivitiesAmusementParks from '@consumer/assets/images/header-v2/activities/amusement-parks.png'
import imageActivitiesBowling from '@consumer/assets/images/header-v2/activities/bowling.png'
import imageActivitiesCasinos from '@consumer/assets/images/header-v2/activities/casinos.png'
import imageActivitiesGolf from '@consumer/assets/images/header-v2/activities/golf.png'
import imageActiviesTopActivities from '@consumer/assets/images/header-v2/activities/top-activities.png'
import imageBrandsAldi from '@consumer/assets/images/header-v2/brands/aldi.png'
import imageBrandsAllegiantAir from '@consumer/assets/images/header-v2/brands/allegiant-air.png'
import imageBrandsHEB from '@consumer/assets/images/header-v2/brands/h-e-b.png'
import imageBrandsJetBlue from '@consumer/assets/images/header-v2/brands/jetblue.png'
import imageBrandsLouisVuitton from '@consumer/assets/images/header-v2/brands/louis-vuitton.png'
import imageBrandsMcDonalds from '@consumer/assets/images/header-v2/brands/mcdonalds.png'
import imageBrandsSpiritAirlines from '@consumer/assets/images/header-v2/brands/spirit-airlines.png'
import imageBrandsVrbo from '@consumer/assets/images/header-v2/brands/vrbo.png'
import imageRestaurantsBars from '@consumer/assets/images/header-v2/going-out/bars.png'
import imageRestaurantsAmerican from '@consumer/assets/images/header-v2/restaurants/american.png'
import imageRestaurantsBreakfastAndBrunch from '@consumer/assets/images/header-v2/restaurants/breakfast-and-brunch.png'
import imageRestaurantsFastFood from '@consumer/assets/images/header-v2/restaurants/fast-food.png'
import imageRestaurantsFineDining from '@consumer/assets/images/header-v2/restaurants/fine-dining.png'
import imageRestaurantsFoodDelivery from '@consumer/assets/images/header-v2/restaurants/food-delivery.png'
import imageRestaurantsTrendyRestaurant from '@consumer/assets/images/header-v2/restaurants/trendy-restaurant.png'
import imageShoppingDepartmentStores from '@consumer/assets/images/header-v2/shopping/department-stores.png'
import imageShoppingGrocery from '@consumer/assets/images/header-v2/shopping/grocery.png'
import imageShoppingHomeDecor from '@consumer/assets/images/header-v2/shopping/home-decor.png'
import imageShoppingMensClothing from '@consumer/assets/images/header-v2/shopping/mens-clothing.png'
import imageShoppingPets from '@consumer/assets/images/header-v2/shopping/pets.png'
import imageShoppingTopStores from '@consumer/assets/images/header-v2/shopping/top-stores.png'
import imageShoppingWomensClothing from '@consumer/assets/images/header-v2/shopping/womens-clothing.png'
import imageSpaAndBeautyAllSpaAndBeauty from '@consumer/assets/images/header-v2/spa-and-beauty/all-spa-and-beauty.png'
import imageSpaAndBeautyDaySpas from '@consumer/assets/images/header-v2/spa-and-beauty/day-spas.png'
import imageSpaAndBeautyMassage from '@consumer/assets/images/header-v2/spa-and-beauty/massage.png'
import imageSpaAndBeautyNailSalons from '@consumer/assets/images/header-v2/spa-and-beauty/nail-salons.png'
import imageTravelAirline from '@consumer/assets/images/header-v2/travel/airline.png'
import imageTravelRideshare from '@consumer/assets/images/header-v2/travel/car-rental.png'
import imageTravelGas from '@consumer/assets/images/header-v2/travel/gas.png'
import imageTravelHotels from '@consumer/assets/images/header-v2/travel/hotels.png'
import imageTravelSkiResorts from '@consumer/assets/images/header-v2/travel/ski-resorts.png'
import imageTravelTopTravel from '@consumer/assets/images/header-v2/travel/top-travel.png'
import imageTravelTours from '@consumer/assets/images/header-v2/travel/tours.png'
import imageUniversalCashGiftsAndCards from '@consumer/assets/images/header-v2/universal/cash-gifts-and-cards.png'
import imageUniversalDigitalGiftCards from '@consumer/assets/images/header-v2/universal/digital-gift-cards.png'
import imageUniversalEGiftsAndECards from '@consumer/assets/images/header-v2/universal/e-gifts-and-e-cards.png'
import imageUniversalEmailGiftCards from '@consumer/assets/images/header-v2/universal/email-gift-cards.png'
import imageUniversalMailableGiftCards from '@consumer/assets/images/header-v2/universal/mailable-gift-cards.png'
import imageUniversalOnlineGiftCards from '@consumer/assets/images/header-v2/universal/online-gift-cards.png'
import imageUniversalPrintableGiftCards from '@consumer/assets/images/header-v2/universal/printable-gift-cards.png'
import imageUniversalTextableGifts from '@consumer/assets/images/header-v2/universal/textable-gifts.png'
import imageUniversalVirtualGiftCards from '@consumer/assets/images/header-v2/universal/virtual-gift-cards.png'

import imageBuyAGiftAnyActivity1 from '@consumer/assets/images/header-v2/buy-a-gift/any-activity-1.png'
import imageBuyAGiftAnyRestaurant1 from '@consumer/assets/images/header-v2/buy-a-gift/any-restaurant-1.png'
import imageBuyAGiftAnySpa1 from '@consumer/assets/images/header-v2/buy-a-gift/any-spa-1.png'
import imageBuyAGiftAnyStore from '@consumer/assets/images/header-v2/buy-a-gift/any-store.png'
import imageBuyAGiftTravel from '@consumer/assets/images/header-v2/buy-a-gift/travel.png'
import { customizerPathFromIdea } from '@consumer/components/GiftlyIdea.vue'
import { v3WithImageBg } from '@consumer/logic/v3'
import type DateStr from '@consumer/types/DateStr'
import { forEach, intersection } from 'lodash-es'
import type { FeaturedCity } from '@consumer/types/serializers'
import { inject } from 'vue'

import {
  faBriefcase,
  faCity,
  faCopyright,
  faFilm,
  faGlobe,
  faIslandTropical,
  faLayerGroup,
  faShoppingBag,
  faSpa,
  faStore,
  faUtensils,
  faGift,
  faBolt,
  type IconDefinition,
  faLocationDot,
  faPalette,
  faHeart,
} from '@fortawesome/pro-light-svg-icons'

export interface Suggestion {
  label: string
  city?: string
  icon?: any
  iconColor?: string
  image?: string
  stateCode?: string
  href?: string
}

export interface Category {
  /**
    * an array of ids that will be hidden when it is active
  **/
  hides?: string[]
  inactiveColorName?: string
  activeColorName?: string
  /**
   * if you need the text to be a gradient... make sure you triple check
   * acessibility contrast on the colors..
   **/
  gradientName?: string
  startDate?: DateStr
  endDate?: DateStr
  title: string
  icon: any
  svgIcon?: Component
  path?: string
  rel?: string
  riveUrl?: string
  links?: Array<{
    name: string
    path: string
    image?: string
    icon?: any
  }>
  buyAGift?: {
    label: string
    path: string
    image: string
  }
}

interface BuyAGift {
  tagline: string
  backgroundImage: string
  maskColor: string
  logoColor?: string
  maskName?: string
  ctaImage: string
}

function buyAGift ({ ctaImage, tagline, backgroundImage, ...idea }: BuyAGift) {
  const places = tagline.startsWith('Any') ? [{ name: tagline, placeType: 'general' }] : []
  return {
    label: tagline,
    image: ctaImage,
    path: customizerPathFromIdea({
      places,
      giftlyMetadata: {
        backgroundImageUrl: `https://assets2.giftly.com/giftly-assets/giftly-designs/backgrounds/header/${backgroundImage}.png`,
        tagline,
        designName: v3WithImageBg,
        ...idea,
      },
    }, { spec: 'header-category-cta', purchaseMethod: 'header' }),
  }
}

export const isActiveCategory = (category: Category, date: DateStr | null) => {
  const {
    startDate,
    endDate,
  } = category
  const dateTime = new Date(date!).getTime()
  return (!startDate || new Date(startDate).getTime() <= dateTime) && (
    !endDate || new Date(endDate).getTime() >= dateTime)
}

export function getCategories (): Record<string, Category> {
  const topCities = inject<FeaturedCity[]>('topCities', [])

  return {
    fathersDay: {
      title: 'Father\'s Day',
      icon: faGift,
      path: '/gift-ideas/occasions/fathers-day?spec=site-nav',
      startDate: new Date('06/05/2025'),
      endDate: new Date('06/17/2025'),
      hides: ['activities'],
      inactiveColorName: '--blue-500',
    },
    quickGift: {
      title: 'Quick Gift',
      icon: faBolt,
      path: '/customize-gift?spec=site-nav',
      gradientName: '--gradient-horiz-text-blue-to-purple',
      hides: ['customize'],
    },
    // this is hardcoded for now but should come from landing page table
    birthdayLandingPage: {
      title: 'Birthday Gifts',
      icon: faGift,
      path: '/gifts/birthday?spec=site-nav',
      gradientName: '--gradient-horiz-text-orange-to-purple',
    },
    valentinesDay: {
      title: 'Valentine\'s Day',
      icon: faHeart,
      path: '/gifts/valentines-day?spec=site-nav',
      startDate: new Date('02/02/2026'),
      endDate: new Date('02/16/2026'),
      hides: ['customize'],
    },
    customize: {
      title: 'Customize',
      icon: faPalette,
      path: '/customize-gift?spec=site-nav',
    },
    restaurants: {
      title: 'Restaurants',
      icon: faUtensils,
      links: [
        {
          name: 'Top US Restaurants',
          path: '/restaurant-gift-cards',
          image: imageRestaurantsTrendyRestaurant,
        },
        {
          name: 'Fast Food',
          path: '/fast-food-gift-cards',
          image: imageRestaurantsFastFood,
        },
        {
          name: 'Food Delivery',
          path: '/food-delivery-gift-cards',
          image: imageRestaurantsFoodDelivery,
        },
        {
          name: 'American',
          path: '/american-restaurant-gift-cards',
          image: imageRestaurantsAmerican,
        },
        {
          name: 'Fine Dining',
          path: '/fine-dining-gift-cards',
          image: imageRestaurantsFineDining,

        },
        {
          name: 'Bars',
          path: '/bar-gift-cards',
          image: imageRestaurantsBars,
        },
        {
          name: 'Breakfast & Brunch',
          path: '/breakfast-brunch-gift-cards',
          image: imageRestaurantsBreakfastAndBrunch,
        },
      ],
      buyAGift: buyAGift({
        tagline: 'Any Restaurant',
        backgroundImage: 'giftly-background-resturant',
        ctaImage: imageBuyAGiftAnyRestaurant1,
        maskColor: '#17496E',
        logoColor: '#00A2F1',
        maskName: 'giftly-v3-mask-2',
      }),
    },
    travel: {
      title: 'Travel',
      icon: faIslandTropical,
      links: [
        {
          name: 'Top Travel Gifts',
          path: '/travel-gift-cards',
          image: imageTravelTopTravel,
        },
        {
          name: 'Airlines & Flights',
          path: '/airline-gift-cards',
          image: imageTravelAirline,
        },
        {
          name: 'Hotels',
          path: '/hotel-gift-cards',
          image: imageTravelHotels,
        },
        {
          name: 'Rideshare',
          path: '/rideshare-gift-cards',
          image: imageTravelRideshare,
        },
        {
          name: 'Tours',
          path: '/tour-gift-cards',
          image: imageTravelTours,
        },
        {
          name: 'Gas',
          path: '/gas-gift-cards',
          image: imageTravelGas,
        },
        {
          name: 'Ski Resorts',
          path: '/ski-resort-gift-cards',
          image: imageTravelSkiResorts,
        },
      ],
      buyAGift: buyAGift({
        tagline: 'Travel',
        backgroundImage: 'giftly-background-travel',
        ctaImage: imageBuyAGiftTravel,
        maskColor: '#196692',
        logoColor: '#073854',
        maskName: 'giftly-v3-mask-6',
      }),
    },
    spaBeauty: {
      title: 'Spa & Beauty',
      icon: faSpa,
      links: [
        {
          name: 'Nail Salons',
          path: '/nail-salon-gift-cards',
          image: imageSpaAndBeautyNailSalons,
        },
        {
          name: 'Spas',
          path: '/day-spa-gift-cards',
          image: imageSpaAndBeautyDaySpas,
        },
        {
          name: 'Massages',
          path: '/massage-gift-cards',
          image: imageSpaAndBeautyMassage,
        },
        {
          name: 'All Spa & Beauty',
          path: '/spa-beauty-gift-cards',
          image: imageSpaAndBeautyAllSpaAndBeauty,
        },
      ],
      buyAGift: buyAGift({
        tagline: 'Any Spa',
        backgroundImage: 'giftly-background-spa',
        ctaImage: imageBuyAGiftAnySpa1,
        maskColor: '#32B6B6',
        logoColor: '#03F3F3',
        maskName: 'giftly-v3-mask-2',
      }),
    },
    activities: {
      title: 'Activities',
      icon: faFilm,
      links: [
        {
          name: 'Top Activities',
          path: '/activity-gift-cards',
          image: imageActiviesTopActivities,
        },
        {
          name: 'Amusement Parks',
          path: '/amusement-park-gift-cards',
          image: imageActivitiesAmusementParks,
        },
        {
          name: 'Bowling',
          path: '/bowling-gift-cards',
          image: imageActivitiesBowling,
        },
        {
          name: 'Casinos',
          path: '/casino-gift-cards',
          image: imageActivitiesCasinos,
        },
        {
          name: 'Golf',
          path: '/golf-gift-cards',
          image: imageActivitiesGolf,
        },
      ],
      buyAGift: buyAGift({
        tagline: 'Any Activity',
        backgroundImage: 'giftly-background-activities',
        ctaImage: imageBuyAGiftAnyActivity1,
        maskColor: '#D65119',
        logoColor: '#FF985E',
      }),
    },
    shopping: {
      title: 'Shopping',
      icon: faShoppingBag,
      links: [
        {
          name: 'Top Stores',
          path: '/shopping-gift-cards',
          image: imageShoppingTopStores,
        },
        {
          name: 'Department Store',
          path: '/department-store-gift-cards',
          image: imageShoppingDepartmentStores,
        },
        {
          name: 'Home Decor',
          path: '/home-decor-gift-cards',
          image: imageShoppingHomeDecor,
        },
        {
          name: 'Grocery',
          path: '/grocery-gift-cards',
          image: imageShoppingGrocery,
        },
        {
          name: 'Pets',
          path: '/pet-gift-cards',
          image: imageShoppingPets,
        },
        {
          name: 'Men\'s Clothing',
          path: '/mens-clothing-gift-cards',
          image: imageShoppingMensClothing,
        },
        {
          name: 'Women\'s Clothing',
          path: '/womens-clothing-gift-cards',
          image: imageShoppingWomensClothing,
        },
      ],
      buyAGift: buyAGift({
        tagline: 'Any Store',
        backgroundImage: 'giftly-background-store',
        ctaImage: imageBuyAGiftAnyStore,
        maskColor: '#196692',
        logoColor: '#073854',
      }),
    },
    universal: {
      title: 'Universal',
      icon: faGlobe,
      links: [
        {
          name: 'Cash Gifts & Cards',
          path: '/lp/cash-gift-cards',
          image: imageUniversalCashGiftsAndCards,
        },
        {
          name: 'E Gifts & E Cards',
          path: '/lp/e-gift-cards',
          image: imageUniversalEGiftsAndECards,
        },
        {
          name: 'Textable Gifts',
          path: '/lp/text-message-gift-cards',
          image: imageUniversalTextableGifts,
        },
        {
          name: 'Email Gift & Cards',
          path: '/lp/email-gift-cards',
          image: imageUniversalEmailGiftCards,
        },
        {
          name: 'Printable Gift & Cards',
          path: '/lp/printable-gift-cards',
          image: imageUniversalPrintableGiftCards,
        },
        {
          name: 'Mailable Gift & Cards',
          path: '/lp/mailable-gift-cards',
          image: imageUniversalMailableGiftCards,
        },
        {
          name: 'Online Gift & Cards',
          path: '/lp/online-gift-cards',
          image: imageUniversalOnlineGiftCards,
        },
        {
          name: 'Digital Gift & Cards',
          path: '/lp/digital-gift-cards',
          image: imageUniversalDigitalGiftCards,
        },
        {
          name: 'Virtual Gift & Cards',
          path: '/lp/virtual-gift-cards',
          image: imageUniversalVirtualGiftCards,
        },
      ],
    },
    brands: {
      title: 'Brands',
      icon: faCopyright,
      links: [
        {
          name: 'Vrbo',
          path: '/gift-card/vrbo',
          image: imageBrandsVrbo,
        },
        {
          name: 'Allegiant Air',
          path: '/gift-card/allegiant-air',
          image: imageBrandsAllegiantAir,
        },
        {
          name: 'JetBlue',
          path: '/gift-card/jetblue',
          image: imageBrandsJetBlue,
        },
        {
          name: 'Louis Vuitton',
          path: '/gift-card/louis-vuitton',
          image: imageBrandsLouisVuitton,
        },
        {
          name: 'Spirit Airlines',
          path: '/gift-card/spirit-airlines',
          image: imageBrandsSpiritAirlines,
        },
        {
          name: 'Aldi',
          path: '/gift-card/aldi',
          image: imageBrandsAldi,
        },
        {
          name: 'McDonalds',
          path: '/gift-card/mcdonalds',
          image: imageBrandsMcDonalds,
        },
        {
          name: 'H-E-B',
          path: '/gift-card/h-e-b',
          image: imageBrandsHEB,
        },
        {
          name: 'All Brands',
          path: '/brands/top-brands-gift-cards',
          icon: faStore,
        },
      ],
    },
    topCities: {
      title: 'Top Cities',
      icon: faCity,
      links: [
        ...topCities.map((mappedCity) => {
          const city: { name: string; city: string; path: string; image?: string; icon?: IconDefinition } = {
            name: mappedCity.name,
            city: mappedCity.name,
            path: mappedCity.giftCardsPath,
          }

          if (mappedCity.imageThumbUrl) {
            city.image = mappedCity.imageThumbUrl
          }
          else {
            city.icon = faLocationDot
          }

          return city
        }),
        {
          name: 'All Cities',
          path: '/top-cities',
          icon: faCity,
        },
      ],
    },
    multiPlace: {
      title: 'Multi-Place',
      icon: faLayerGroup,
      path: '/mp',
      rel: 'nofollow',
    },
    corporate: {
      title: 'Corporate',
      icon: faBriefcase,
      path: '/corp',
    },
  }
}

export const categories = computed(() => getCategories())

/**
 * This function will check the url parameters
  * for a date query, if none is present it will assume todays
  * date and return an array or categories to be displayed in
  * order.
  **/
export const getActiveCategories = (): Category[] => {
  const date = new Date().toString()
  const hiddenKeys = new Set<string>([])
  const visibleKeys = new Set<string>([])
  const displayedCategories: Record<string, Category> = {}
  forEach(categories.value, (value, key) => {
    if (isActiveCategory(value, date) && !hiddenKeys.has(key)) {
      displayedCategories[key] = value
      if (value.hides) {
        forEach(value.hides, val => hiddenKeys.add(val))
      }
      visibleKeys.add(key)
    }
  })

  const overlap = intersection([...hiddenKeys], [...visibleKeys])
  if (overlap.length === 0) {
    const result: Category[] = []
    forEach(displayedCategories, (value) => {
      result.push(value)
    })
    return result
  }
  else {
    const result: Category[] = []
    forEach(displayedCategories, (value, key) => {
      if (!hiddenKeys.has(key)) {
        result.push(value)
      }
    })
    return result
  }
}

export const pageTitle = reactive<{
  text?: string | null
  href?: string
}>({})
